// Recipes section JavaScript
(function() {
  const RECIPES_PER_LOAD = 9;

  // Handleize for JS comparison (match Liquid: lowercase, hyphenate spaces/special chars)
  function handleize(value) {
    if (value == null || value === '') return '';
    return String(value)
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function getSectionContext(filterOrContainer) {
    var section = filterOrContainer.closest('section');
    if (!section) section = filterOrContainer.closest('.section-recipes');
    if (!section) return null;
    var recipesContainer = section.querySelector('[data-recipes-container]');
    if (!recipesContainer) return null;
    var featuredSlot = recipesContainer.querySelector('[data-recipes-featured-slot]');
    var loadMoreBtn = section.querySelector('[data-load-more]');
    return {
      section: section,
      recipesContainer: recipesContainer,
      featuredSlot: featuredSlot,
      loadMoreBtn: loadMoreBtn
    };
  }

  function getCardItems(recipesContainer) {
    return Array.from(recipesContainer.children).filter(function(el) {
      return el.getAttribute('data-recipe-item') !== null && el.getAttribute('data-recipe-category') !== null;
    });
  }

  function setActiveFilter(ctx, filterEl) {
    ctx.section.querySelectorAll('[data-filter-category]').forEach(function(el) {
      el.classList.remove('active');
    });
    if (filterEl) filterEl.classList.add('active');
  }

  function getActiveFilterCategory(ctx) {
    var activeFilter = ctx.section.querySelector('[data-filter-category].active');
    if (!activeFilter) return '';
    var raw = activeFilter.getAttribute('data-filter-category') || '';
    return handleize(raw);
  }

  function applyFilter(ctx) {
    var filterCategory = getActiveFilterCategory(ctx);
    var isAll = filterCategory === '' || filterCategory === 'all';
    var recipesContainer = ctx.recipesContainer;
    var featuredSlot = ctx.featuredSlot;
    var loadMoreBtn = ctx.loadMoreBtn;

    // Featured slot: show first recipe that matches filter; remember its recipe index to hide same recipe in grid
    var featuredRecipeIndex = null;
    if (featuredSlot) {
      var featuredItems = featuredSlot.querySelectorAll('.recipes-featured-item');
      var firstMatchFound = false;
      featuredItems.forEach(function(item) {
        var recipeCategory = handleize(item.getAttribute('data-recipe-category') || '');
        var matches = isAll || recipeCategory === filterCategory;
        if (matches && !firstMatchFound) {
          item.classList.remove('recipes-featured-item-hidden');
          featuredRecipeIndex = item.getAttribute('data-recipe-index');
          firstMatchFound = true;
        } else {
          item.classList.add('recipes-featured-item-hidden');
        }
      });
    }

    // Cards: show by category, but hide the card that is the same recipe as the featured one
    var cardItems = getCardItems(recipesContainer);
    var visibleWhenAll = featuredSlot ? RECIPES_PER_LOAD : RECIPES_PER_LOAD + 1;

    cardItems.forEach(function(item, index) {
      var recipeCategory = handleize(item.getAttribute('data-recipe-category') || '');
      var matches = isAll || recipeCategory === filterCategory;
      var recipeRecipeIndex = item.getAttribute('data-recipe-recipe-index');
      var isFeaturedRecipe = featuredRecipeIndex !== null && recipeRecipeIndex === featuredRecipeIndex;

      if (!matches || isFeaturedRecipe) {
        item.classList.add('recipes-item-hidden');
        return;
      }
      if (isAll) {
        if (index < visibleWhenAll) {
          item.classList.remove('recipes-item-hidden');
        } else {
          item.classList.add('recipes-item-hidden');
        }
      } else {
        item.classList.remove('recipes-item-hidden');
      }
    });

    if (loadMoreBtn) {
      if (isAll) {
        loadMoreBtn.style.display = '';
        checkLoadMoreVisibility(ctx);
      } else {
        loadMoreBtn.style.display = 'none';
      }
    }
  }

  function getHiddenRecipes(recipesContainer) {
    var cards = getCardItems(recipesContainer);
    return Array.from(cards)
      .filter(function(el) {
        return el.classList.contains('recipes-item-hidden');
      })
      .sort(function(a, b) {
        return parseInt(a.getAttribute('data-recipe-index'), 10) - parseInt(b.getAttribute('data-recipe-index'), 10);
      });
  }

  function checkLoadMoreVisibility(ctx) {
    if (!ctx.loadMoreBtn) return;
    var hiddenRecipes = getHiddenRecipes(ctx.recipesContainer);
    ctx.loadMoreBtn.style.display = hiddenRecipes.length === 0 ? 'none' : 'block';
  }

  function initSection(ctx) {
    if (!ctx.loadMoreBtn) return;
    ctx.loadMoreBtn.addEventListener('click', function() {
      var hiddenRecipes = getHiddenRecipes(ctx.recipesContainer);
      var nextBatch = hiddenRecipes.slice(0, RECIPES_PER_LOAD);
      nextBatch.forEach(function(item) {
        item.classList.remove('recipes-item-hidden');
      });
      checkLoadMoreVisibility(ctx);
    });
    checkLoadMoreVisibility(ctx);
  }

  // Document-level delegation: works no matter which section or how many
  document.addEventListener('click', function(e) {
    var filterEl = e.target.closest('[data-filter-category]');
    if (!filterEl) return;
    var ctx = getSectionContext(filterEl);
    if (!ctx) return;
    setActiveFilter(ctx, filterEl);
    applyFilter(ctx);
  });

  document.addEventListener('DOMContentLoaded', function() {
    var containers = document.querySelectorAll('[data-recipes-container]');
    containers.forEach(function(recipesContainer) {
      var ctx = getSectionContext(recipesContainer);
      if (ctx) {
        initSection(ctx);
        applyFilter(ctx);
      }
    });
  });
})();